import { render } from "./share.vue?vue&type=template&id=c3ea1008&scoped=true"
import script from "./share.vue?vue&type=script&lang=js"
export * from "./share.vue?vue&type=script&lang=js"

import "./share.vue?vue&type=style&index=0&id=c3ea1008&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3ea1008"]])

export default __exports__